import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePlaceAvailability } from './_load/PlaceAvailabilityLoader'
import { useChangeAvailabilityStatusAction } from '../_actions/useAvailabilityActionsList'
import AvailabilityStatusTag from '../_shared/AvailabilityStatusTag'
import Button from '../../../packages/kiti/components/actions/Button'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'
import { Title } from '../../../components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation('availability')
  const place = usePlaceAvailability()
  const canEdit = useSessionPermission('editPlaceAvailabilityStatus')
  const changeStatus = useChangeAvailabilityStatusAction(place)

  return (
    <>
      <FlexGrid justify="flex-start" gutter={0.3} align="center">
        <FlexCol flex={1}>
          <Title size="h4" strong color={COLORS.dark2} noMargin>
            {place.name}
          </Title>
          <AvailabilityStatusTag status={place.availabilityStatus} />
        </FlexCol>

        {canEdit && (
          <FlexCol>
            <Button size="small" transparent color="dark3" onClick={changeStatus.click}>
              {t('changeStatusManually')}
            </Button>
          </FlexCol>
        )}
      </FlexGrid>

      <Separator weight={6} />

      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
